import React from 'react';
import { connect } from 'react-redux';
import Page from '../../components/page';
import Button, { ButtonGroup } from '../../components/button';
import { redirectTo } from '../../actions/utils';
import { changeOtpPath } from '../../routeConstants';
import { I18n } from 'react-redux-i18n';
import spinner from '../../static/spinner.gif';
import { delOtpSecret } from '../../actions';
import Warning from 'components/warning';

import pofhConfig from '../../pofhConfig';
const { otpEnabled } = pofhConfig.appSettings;

class OtpOffPage extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      step: this.checkOtpStatus(),
      error: false,
    };
    this.goBack = this.goBack.bind(this);
    this.checkOtpStatus = this.checkOtpStatus.bind(this);
  }

  checkOtpStatus() {
    return otpEnabled ? (
      1
    ) : (
      0
    )
  }

  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1
    });
  }

  onSubmit() {
    return this.props.delOtpSecret()
    .then(() => {
        this.nextStep()
    }).catch(() =>
      this.setState({
        error: true
    })
    )
  }

  goBack() {
    redirectTo(changeOtpPath);
  }

  render() {
    const {step} = this.state;

    switch (step) {
      case 1:
        return (
          <Page
            header={I18n.t('general.otp_popup_header')}
            infoText={I18n.t('general.otp_popup_text')}
            goBackRoute={changeOtpPath}
          >
            <ButtonGroup>
              <Button type='button'
                onClick={this.goBack}
                text={I18n.t('general.cancel')}
                secondary
              />
              <Button type='submit'
                onClick={this.onSubmit}
                text={I18n.t('general.otp_confirm_off')}
              />
            </ButtonGroup>
            {this.state.error &&
              <Warning text={I18n.t("general.otp_reset_error")} color="red" formWarning={true} />
            }
          </Page>
        )
      case 2:
        return (
          <Page header={I18n.t('general.otp_header')}
          infoText={I18n.t('general.otp_off_text')}
          goBackRoute={changeOtpPath}
          >
            <Button
              type="button"
              onClick={this.goBack}
              text={I18n.t('general.finish')}
              wide
            />
          </Page>
        )
      default:
        return (
          <Page header={I18n.t('general.otp_header')}>
            <img className="spinner" src={spinner} alt="spinner" />
          </Page>
        )
    }
  }
}

function mapStateToProps(state) {
  return {
    locale: state.i18n.locale,
  };
}

export default connect(mapStateToProps, {
  delOtpSecret,
})(OtpOffPage);
